import { connect } from 'react-redux';

import { GET_PLACE_DETAIL, RESET_PLACE_DETAILS } from 'store/place/actionTypes';
import { GET_USABLE_MARKETING_PROMOTION_LIST } from 'store/promotion/actionTypes';

import CreatePromotion from './CreatePromotion';

const mapStateToProps = (state) => ({
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,
  placeDetail: state.Place.placeDetail,
  isLoadingGetUsableMarketingPromotionList:
    state.Promotion.isLoadingGetUsableMarketingPromotionList,
  usableMarketingPromotionList: state.Promotion.usableMarketingPromotionList,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),
  actionResetPlaceDetail: () => dispatch({
    type: RESET_PLACE_DETAILS,
  }),
  actionGetUsableMarketingPromotionList: (payload) => dispatch({
    type: GET_USABLE_MARKETING_PROMOTION_LIST,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreatePromotion);
